import React from "react";
import { components, StylesConfig } from "react-select";

import { ReactComponent as RemoveImage } from "static/images/cancel.svg";

export const IndicatorsContainer = props => (
	<components.IndicatorsContainer {...props}>
		Please Select {props.children}
	</components.IndicatorsContainer>
);

export const MultiValueRemove = props => (
	<components.MultiValueRemove {...props}>
		<RemoveImage />
	</components.MultiValueRemove>
);

export const customMultiSelectStyles: StylesConfig<unknown, boolean> = {
	option: provided => ({
		...provided,
		width: "100%",
	}),
	control: (provided, state) => ({
		...provided,
		border: 0,
		height: "auto",
		paddingTop: "34px",
		boxShadow: state.isFocused ? "none" : undefined,
	}),
	indicatorsContainer: provided => ({
		...provided,
		border: "1px solid #616161",
		width: "100%",
		height: "34px",
		fontSize: "14px",
		color: "#747474",
		padding: "5px 0 5px 8px",
		justifyContent: "space-between",
		position: "absolute",
		top: 0,
		left: 0,
	}),
	multiValue: () => ({
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
		padding: "5px 0",
	}),
	multiValueLabel: () => ({}),
	valueContainer: provided => ({ ...provided, padding: 0 }),
	multiValueRemove: () => ({
		color: "#13acc5",
		cursor: "pointer",
		width: "12px",
		height: "12px",
		marginRight: "8px",
	}),
	menu: provided => ({
		...provided,
		top: "34px",
	}),
	input: () => ({
		position: "absolute",
		top: "-34px",
		left: 0,
	}),
};
